import Profile from "./pages/profile";
import Contact from "./pages/contact";
import Training from "./pages/training";
import TrainingDetails from "./pages/trainingDetails";
import TrainingRates from "./pages/trainingRates";
import Equipments from "./pages/equipments";
import Partnerships from "./pages/partnerships";
import Research from "./pages/research";

type RouteItem = {
  key: string;
  route: string;
  component: React.ReactNode;
};

type ParentRoute = {
  key: string;
  children: RouteItem[];
};

type RouteKey = RouteItem | ParentRoute;

export type { RouteItem, ParentRoute, RouteKey };

export const routeKeys: RouteKey[] = [
  {
    key: "profile",
    route: "/profile",
    component: <Profile />,
  },
  {
    key: "training",
    children: [
      {
        key: "trainingOverview",
        route: "/training/overview",
        component: <Training />,
      },
      {
        key: "trainingDetails",
        route: "/training/details",
        component: <TrainingDetails />,
      },
      {
        key: "trainingRates",
        route: "/training/rates",
        component: <TrainingRates />,
      },
    ],
  },
  {
    key: "partnerships",
    route: "/partnerships",
    component: <Partnerships />,
  },
  {
    key: "research",
    route: "/research",
    component: <Research />,
  },
  {
    key: "equipments",
    route: "/equipments",
    component: <Equipments />,
  },
  {
    key: "blog",
    route: "https://note.com/sharkshooter2011",
    component: null,
  },
  {
    key: "contact",
    route: "/contact",
    component: <Contact />,
  },
];

// Legacy export for backward compatibility
const routes: RouteItem[] = routeKeys.flatMap((r) =>
  "children" in r ? r.children : [r],
);

export default routes;
